import React, {useContext} from "react";
import BusinessServiceContext from "../../../../../providers/Service/business";
import {ServiceSummary} from "../../../Shared/Summary";
export const Summary = () => {
  const {service} = useContext(BusinessServiceContext);
  return <ServiceSummary summary={service.summary} />;
};
